export default __webpack_public_path__ + "static/media/this_is_your_home_mobile.4e02ed8b.webp";